import React, { useEffect, useState } from "react";
import { api } from "@/lib/api";
import { Button } from "@/components/ui/button";
import { toast } from "sonner";
import {
  TrendingUp, Plane, Home, Briefcase, GraduationCap, Rocket,
  Building2, Landmark, Stethoscope, HeartHandshake, CheckCircle2,
} from "lucide-react";

const categories = [
  { icon: Stethoscope, label: "Higher-paying bedside specialties" },
  { icon: HeartHandshake, label: "PRN strategies" },
  { icon: Plane, label: "Travel nursing" },
  { icon: Home, label: "Remote nursing" },
  { icon: Briefcase, label: "Case management" },
  { icon: TrendingUp, label: "Leadership" },
  { icon: Stethoscope, label: "Advanced practice" },
  { icon: GraduationCap, label: "Graduate education" },
  { icon: Rocket, label: "Nurse entrepreneurship" },
  { icon: Landmark, label: "Government & contract opportunities" },
];

export default function Career() {
  const [joined, setJoined] = useState(false);

  useEffect(() => { api.get("/waitlist/status").then((r) => setJoined(r.data.joined)).catch(() => {}); }, []);

  const join = async () => {
    try {
      const { data } = await api.post("/waitlist", { feature_interest: "Career Roadmap" });
      setJoined(true);
      toast.success(data.message);
    } catch { toast.error("Could not join right now."); }
  };

  return (
    <div className="space-y-6">
      <div>
        <p className="text-xs font-bold uppercase tracking-widest text-[#D6A84B]">Career Roadmap · Coming Soon</p>
        <h1 className="mt-1 font-heading text-3xl font-extrabold text-[#0F2747]">Your Next Nursing Career Move</h1>
      </div>

      <div className="rounded-3xl border border-[#D6A84B]/30 bg-gradient-to-br from-[#0F2747] to-[#16355F] p-8 text-white shadow-xl">
        <p className="max-w-2xl text-lg text-slate-200">
          Soon, RN Level Up will help you explore nursing career paths based on your experience,
          specialty, income goals, and lifestyle preferences.
        </p>
        {joined ? (
          <div className="mt-6 inline-flex items-center gap-2 rounded-full bg-[#18A6A6]/20 px-5 py-3 font-semibold text-[#18A6A6]" data-testid="waitlist-joined">
            <CheckCircle2 className="h-5 w-5" /> You're on the list! We'll let you know when it launches.
          </div>
        ) : (
          <Button onClick={join} data-testid="join-waitlist-btn"
            className="mt-6 rounded-full bg-[#D6A84B] px-7 py-6 font-semibold text-[#0F2747] hover:bg-[#c69a3f]">
            Join the Early Access List
          </Button>
        )}
      </div>

      <div>
        <h2 className="font-heading text-lg font-bold text-[#0F2747]">Preview of future categories</h2>
        <div className="mt-4 grid gap-3 sm:grid-cols-2 lg:grid-cols-3">
          {categories.map(({ icon: Icon, label }) => (
            <div key={label} className="flex items-center gap-3 rounded-2xl border border-slate-200/80 bg-white p-4 shadow-sm">
              <div className="flex h-10 w-10 items-center justify-center rounded-xl bg-[#EAF4FA] text-[#18A6A6]">
                <Icon className="h-5 w-5" />
              </div>
              <span className="text-sm font-medium text-[#0F2747]">{label}</span>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
}
